import { DayOfWeek } from '../../enums/DayOfWeek';
import { enumParse } from '../../../pipes/enum-parse.pipe';
import { AbstractPreferredTimeOff } from './AbstractPreferredTimeOff';

/**
 * A class defines, what times an employee would prefer to have off.
 */
export class PreferredTimeOff extends AbstractPreferredTimeOff {
  dayOfWeek: DayOfWeek;
  reason: string;
  startTime: string;
  endTime: string;
  startDate: string;

  /**
   * @param dayOfWeek the day of a week that employee would prefer not to work on.
   * @param reason the human-readable reason, why the employee would prefer not to be working this day.
   * @param startTime the beginning of the period where the setting applies.
   * @param endTime the end of the period where the setting applies.
   * @param startDate the Monday from which this setting takes effect.
   */
  constructor(
    dayOfWeek: DayOfWeek,
    reason: string,
    startTime: string,
    endTime: string,
    startDate: string
  ) {
    super(dayOfWeek, reason, startTime, endTime);
    this.startDate = startDate;
  }

  getFormattedDate(): string {
    return 'Every ' + enumParse(this.dayOfWeek);
  }
}

